import { useState, useEffect, createContext, useCallback } from "react";
import { User, Auth } from "../api";
import { hasexpiredToken } from "../Utils";

const usercontroller = new User();
const authcontroller = new Auth();

export const AuthContext = createContext();

export function AuthProvider(props) {
  const { children } = props;
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = useCallback(async (accessToken, userData = null) => {
    //console.log("Llamada a login con:", { accessToken, userData });

    try {
      if (!userData) {
        console.log("Cargando datos del usuario desde la API con el token...");
        userData = await usercontroller.getMe(accessToken);
      }
      //console.log("Usuario obtenido:", userData);
      delete userData.password; // Eliminar la contraseña antes de guardar
      setUser(userData);
      setToken(accessToken);
    } catch (error) {
      console.error("Error al autenticar:", error);
    }
  }, []);

  const reLogin = useCallback(
    async (refreshToken) => {
      try {
        const { accessToken } =
          await authcontroller.refreshAccessToken(refreshToken);
        authcontroller.setAccessToken(accessToken);
        await login(accessToken);
      } catch (error) {
        console.error(error);
      }
    },
    [login],
  );

  const logout = () => {
    authcontroller.removeTokens();
    setUser(null);
    setToken(null);
  };

  useEffect(() => {
    (async () => {
      try {
        const accessToken = authcontroller.getAccessToken();
        const refreshToken = authcontroller.getRefreshToken();
        if (!accessToken || !refreshToken) {
          logout();
          setLoading(false);
          return;
        }
        if (hasexpiredToken(accessToken)) {
          if (hasexpiredToken(refreshToken)) {
            logout();
          } else {
            await reLogin(refreshToken);
          }
        } else {
          await login(accessToken);
        }
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reLogin, login]);

  const data = { accessToken: token, user, login, logout };

  if (loading) {
    return <h1>Loading...</h1>;
  }

  return <AuthContext.Provider value={data}>{children}</AuthContext.Provider>;
}
